export default function getBulkDiscount(bulkDiscounts, quantity, subtotal) {
  if (!bulkDiscounts || bulkDiscounts.length === 0) {
    return {
      bulkDiscount: null,
      bulkDiscountAmount: 0,
    };
  }

  // get array of bulkDiscounts that match
  const bulkDiscountsToApply = bulkDiscounts.filter(
    discount =>
      quantity >= discount.minQuantity &&
      (discount.maxQuantity ? quantity <= discount.maxQuantity : true),
  );

  if (bulkDiscountsToApply.length === 0) {
    return {
      bulkDiscount: null,
      bulkDiscountAmount: 0,
    };
  }

  // Find the highest minQuantity
  const highestMinQuantity = Math.max(...bulkDiscountsToApply.map(d => d.minQuantity));

  // Get the first discount with the highest minQuantity
  const discount = bulkDiscountsToApply.find(d => d.minQuantity === highestMinQuantity);

  if (!discount) {
    return {
      bulkDiscount: null,
      bulkDiscountAmount: 0,
    };
  }

  if (discount.amountOff) {
    const discountAmount = discount.amountOff * quantity;
    const cappedDiscountAmount = Math.min(discountAmount, subtotal);

    return {
      bulkDiscount: {
        ...discount,
        amount: cappedDiscountAmount,
      },
      bulkDiscountAmount: cappedDiscountAmount,
    };
  } else {
    const discountAmount = subtotal * (discount.percentOff / 100);

    return {
      bulkDiscount: {
        ...discount,
        amount: discountAmount,
      },
      bulkDiscountAmount: discountAmount,
    };
  }
}
